<template>
  <div>
    <h3 class="mb-4 text-responsible">
      {{ text.titulo_botoes_selecionar_sistemas }}
    </h3>

    <div class="d-flex flex-wrap content-responsible">
      <v-tooltip
        bottom
        v-for="(system, index) in systems"
        :key="system.name"
        color="black"
        :disabled="!hasTooltip(system.name)"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            v-if="system.isVisible"
            v-bind="attrs"
            v-on="on"
            :class="[
              system.isSelected ? 'item-container-active' : 'item-container',
              { 'disabled-item': system.isDisabled && !system.isSelected }
            ]"
            :disabled="system.disabled"
            @click="selectOption(system, index)"
            style="min-width: 200px;"
          >
            <h2 class="text-center">{{ system.name }}</h2>
          </div>
        </template>
        <div>
          <div class="mt-3">
            Será necessário convidar usuários para os sistemas
            <ul class="mt-1">
              <li>ABR/BCI</li>
              <li>SBRHVI</li>
            </ul>
          </div>
        </div>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import text from "./text";

export default {
  data: () => ({
    text: text,
    systems: [
      {
        name: "ABR/BCI",
        isSelected: false,
        isDisabled: false,
        isVisible: true
      },
      {
        name: "SBRHVI",
        isSelected: false,
        isDisabled: false,
        isVisible: true
      }
    ]
  }),
  methods: {
    selectOption(option, index) {
      if (!option.disabled) {
        if (option.name === "ABR/BCI" && !option.isSelected) {
          this.systems[1].isSelected = true;
          this.systems[1].disabled = true;
        }
        if (option.name === "ABR/BCI" && option.isSelected) {
          this.systems[1].disabled = false;
        }
        this.systems[index].isSelected = !this.systems[index].isSelected;
        this.$emit(
          "onSelectSystems",
          this.systems.filter(system => system.isSelected)
        );
      }
    },
    hasTooltip(systemName) {
      return systemName === "ABR/BCI";
    }
  },
  computed: {
    isOnSelectedDate() {
      const today = new Date();
      const year = today.getFullYear();

      // Normalizando as datas (removendo horário)
      const normalizeDate = date =>
        new Date(date.getFullYear(), date.getMonth(), date.getDate());

      // const startDate = new Date(year, 0, 1); // 1 de janeiro - data para os testes
      // const endDate = new Date(year, 1, 31); // 31 de dezembro - data para os testes
      const startDate = new Date(year, 1, 26); // 26 de fevereiro - data real
      const endDate = new Date(year, 5, 30); // 30 de junho - data real

      // Convertendo para a versão sem horário
      const startDateNormalized = normalizeDate(startDate);
      const todayNormalized = normalizeDate(today);
      const endDateNormalized = normalizeDate(endDate);

      // Verificando se hoje está entre a data de início e a data de fim
      const startDateCheck = todayNormalized >= startDateNormalized;
      const endDateCheck = todayNormalized <= endDateNormalized;

      return startDateCheck && endDateCheck;
    }
  },
  created() {
    const visible = this.isOnSelectedDate;
    const abrSystem = this.systems.find(system => system.name === "ABR/BCI");
    if (abrSystem) {
      abrSystem.isVisible = visible;
    }
  },

  mounted() {
    this.isOnSelectedDate;
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/stylesheets/styleguide";

.item-container {
  cursor: pointer;
  max-width: 250px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: 16px;
  margin-right: 16px;
  &:hover {
    border: 1px solid $primary-color-1;
    transition: 0.4s;
    h2 {
      transition: 0.5s;
      color: $primary-color-1;
    }
  }
}

.item-container-active {
  cursor: pointer;
  max-width: 250px;
  background-color: $primary-color-1;
  border: 1px solid $primary-color-1;
  color: white;
  border-radius: 4px;
  padding: 8px 16px;
  margin-bottom: 16px;
  margin-right: 16px;
  h2 {
    transition: 0.5s;
    color: white;
  }
}

.disabled-item {
  cursor: default;
  border: 1px solid #ccc;
  &:hover {
    border: 1px solid #ccc;
    h2 {
      color: #000;
    }
  }
}

@media screen and (max-width: 960px) {
  .text-responsible {
    text-align: center;
  }

  .content-responsible {
    justify-content: center;
    align-items: center;
  }
}
</style>

<style></style>
